import { useState, useEffect } from 'react';
import { RulesService } from '../api/rules';

export const useRules = () => {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadRules = async () => {
      try {
        const data = await RulesService.fetchRules();
        setRules(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadRules();
  }, []);

  return { rules, loading, error };
};
